import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { AccountService } from '../account.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Account } from '../../shared/models';
import { finalize, switchMap, take, tap } from 'rxjs/operators';
import { GoogleIntegrationDetails } from '../../shared/models/google-integration-details';
import { GoogleIntegrationService } from '../../shared/google-integration.service';
import { SessionService } from '../../shared';

@Component({
  selector: 'app-google-tag-manager-setup',
  templateUrl: './google-tag-manager-setup.component.html',
  styleUrl: './google-tag-manager-setup.component.scss'
})
export class GoogleTagManagerSetupComponent implements OnInit {
  loading = false;
  checked = false;
  verified = false;
  account: Account;
  details: GoogleIntegrationDetails = { } as GoogleIntegrationDetails;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private accountService: AccountService,
    private sessionService: SessionService,
    private googleIntegrationService: GoogleIntegrationService,
    private cdRef: ChangeDetectorRef
  ) { }

  ngOnInit() {
    this.loading = true;
    const yToken = this.route.snapshot.queryParams['y'];

    this.accountService.ssoTokenAuthentication(yToken).pipe(
      tap(account => this.account = account),
      take(1),
      switchMap(() => this.googleIntegrationService.getDetails(this.account.id)),
      finalize(() => {
        this.resetRoute();
        this.loading = false;
        this.cdRef.detectChanges();
      })
    ).subscribe(
      (details) => this.details = details,
      (err) => this.router.navigateByUrl('log-out')
    );
  }

  verifyGtmTag(): void {
    this.loading = true;
    this.checked = true;
    this.googleIntegrationService.verifyGtmTag(this.account.id)
      .subscribe({
        next: isVerified => {
          this.verified = isVerified;
          if (isVerified) {
            setTimeout(() => {
              this.router.navigateByUrl('accounts');
            }, 5000);
          }
        },
        error: () => this.verified = false,
        complete: () => this.loading = false
      });
  }

  private resetRoute() {
    // clears query params from url
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: {},
      replaceUrl: true
    });
  }
}
